type TSyncstepName = 'ad' | 'p360' | 'azure' | 'eqs';